export enum WishEnum {
  WISH_AFTER_STUDY = 'APRES_ETUDES',
  WISH_BEFORE_THIRTY = 'AVANT_30_ANS',
  WISH_SOME_DAY = 'UN_JOUR',
}
